import { render, staticRenderFns } from "./FileBuckets.vue?vue&type=template&id=49de8432&"
import script from "./FileBuckets.vue?vue&type=script&lang=js&"
export * from "./FileBuckets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports